import { supabase } from "../supabase/SupabaseClient";
import { FLOTABOT } from "../components/layout/secciones";

/* ¿A esta persona le puede escribir el bot por WhatsApp?
 *
 * Nico, 06/10: si se presta una herramienta, el bot le avisa a la persona el
 * día anterior y el mismo día del vencimiento. *«Si al asignar/prestar la
 * persona no está en la lista de WhatsApp, mostrar un cartel avisando que no
 * está y sugiriendo agregarla, para tener todo el flujo.»*
 *
 * ── PREGUNTA AL BOT, NO LO DEDUCE ACÁ ───────────────────────────────────────
 *
 * El que decide a quién le escribe es el bot (`herramientas_devolucion` en
 * fleet-bot-pastor): los choferes por `choferes_wa` y el resto por la lista
 * del bot, que el hub no lee. Contestar acá con otra regla diría «está» de
 * alguien a quien el recordatorio no le va a llegar. Mismo criterio que
 * `guiaDelBot.js`: se manda el token y el bot chequea el permiso.
 *
 * ── SI NO SE PUEDE PREGUNTAR, NO SE AFIRMA NADA ─────────────────────────────
 *
 * Red caída o el bot sin la ruta todavía: `null`, y la pantalla no muestra
 * cartel. Decir «no está» sin saberlo mandaría a dar de alta a alguien que ya
 * está.
 *
 * Devuelve `{ enLista, como, agregar: {rotulo, url, interno} | null }`.
 */
export async function enLaListaDeWhatsapp(dni) {
  const d = String(dni || "").trim();
  if (!d) return null;
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (!token) return null;
    const r = await fetch(`${FLOTABOT}/herramientas/whatsapp?dni=${encodeURIComponent(d)}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!r.ok) return null;
    const j = await r.json();
    if (!j || typeof j.en_lista !== "boolean") return null;
    const a = j.agregar;
    return {
      enLista: j.en_lista,
      como: j.como || null,
      agregar: a && a.url && a.rotulo
        ? { rotulo: String(a.rotulo), url: String(a.url), interno: !!a.interno }
        : null,
    };
  } catch {
    return null;
  }
}
